<template>
  <div class="chevron-down">
    <svg
      class="icon rotate-icon"
      viewBox="0 0 24 24"
      :style="rotate ? 'transform:rotate(180deg)' : ''"
    >
      <path
        fill="currentColor"
        d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z"
      />
    </svg>
  </div>
</template>
<script>
export default {
  props: ['rotate'],
}
</script>
<style lang="less">
@import '../../style/variables.less';
.rotate-icon {
  transition: transform 0.6s ease;
  width: 24px;
  height: 24px;
}
@media (min-width: @width-device-md) {
  .chevron-down {
    margin-bottom: -15px;
    cursor: pointer;
  }
}
.chevron-down:hover {
  background: @color-grey-light;
}
</style>
